import { Key } from 'ts-key-enum';
export const genericNormalizedKeyboardEventCriteria = {
    altKey: false,
    ctrlKey: false,
    metaKey: false,
    shiftKey: false,
    key: Key.Unidentified,
};
// We need a list of keys in order so we can stringifiy keyboard event criteria
// and guarantee they'll come out the same way.
export const NormalizedKeyboardEventCriteriaKeys = Object.keys(genericNormalizedKeyboardEventCriteria);
/**
 * This converts a KeyboardEvent to its matching NormalizedKeyboardEventCriteria.
 */
export function normalizeKeyboardEvent(event) {
    return {
        altKey: event.altKey === true,
        ctrlKey: event.ctrlKey === true,
        metaKey: event.metaKey === true,
        shiftKey: event.shiftKey === true,
        key: event.key,
    };
}
/**
 * This converts a KeyboardEventCriteria to its matching NormalizedKeyboardEventCriteria.
 */
export function normalizeKeyboardEventCriteria(event, osModifierKey) {
    return {
        altKey: event.altKey === true,
        shiftKey: event.shiftKey === true,
        key: event.key,
        ctrlKey: false,
        metaKey: false,
        [osModifierKey]: event.osModifierKey === true,
    };
}
//# sourceMappingURL=keyboard_binding.preenvesnextjs.map
